import React from "react";

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/shared/Layout";

import Overall from "./components/Overall";
import MainCommodity from "./components/MainCommodityLayout";

import Spice from "./components/SpiceLayout";
import Fruit from "./components/FruitLayout";
import Pulse from "./components/PulseLayout";
import OilSeed from "./components/OilSeedsLayout";
import Vegetable from "./components/VegetableLayout";
import RootCrop from "./components/RootCropLayout";
import BuildingMaterials from "./components/BuildingMaterilsLayout";
import GrainsAndCereals from "./components/GrainsAndCerealsLayout";
import UserAndNews from "./components/UserAndNewsLayout";
import CreatePost from "./components/ContentManagement/CreatePost";
import AddExchangeRate from "./components/ContentManagement/AddExchangeRate";
import Posting_form_admin from "./components/OfferManagement/CreateOffer";
import CreateProduct from "./components/productManagement/CreateProduct";
import CreateProperty from "./components/productManagement/CreateProperty";
import CreatePropertyValue from "./components/productManagement/CreatePropertyValue";
import PreViewPosts from "./components/ContentManagement/PreViewPosts";
import EditPost from "./components/ContentManagement/EditPost";
import Login from "./components/shared/Login";
import RequireAuth from "./components/shared/RequireAuth";
import RequireRole from "./components/shared/RequireRole";
import AddAdmin from "./components/UserManagement/AddAdmin";
import RemoveAdmin from "./components/UserManagement/RemoveAdmin";
import ListOffer from "./components/OfferManagement/ListOffer";
import Users from "./components/UserManagement/Users";
import ProductPrice from "./components/productManagement/ProductPrice";
import ProductValueCalc from "./components/productManagement/ProductValueCalc";
import ContentListPage from "./components/ContentManagement/ContentListPage";
import PostStatistics from "./components/ContentManagement/PostStatistics";
import ValueTrend from "./components/productManagement/ValueTrend";
import TotalViewForUserPost from "./components/productManagement/TotalViewForUserPost";
import TotalPostForUserPost from "./components/productManagement/TotalPostForUserPost";
import PowerBI from "./components/Post&ValueTrends/PowerBI";
import PostInfo from "./components/Post&ValueTrends/PostInfo";
import PreViewResource from "./components/ContentManagement/PreViewResource";
import CreateResource from "./components/ContentManagement/CreateResource";
import Inquiry_form_admin from "./components/OfferManagement/CreateInquiry";
import KYCList from "./components/KYC/KYCList";
// NOTE: Notification Manager commented out - not in current project scope
// import NotificationManagerLayout from "./components/NotificationManager/NotificationManagerLayout";
// import UserNotifications from "./components/NotificationManager/UserNotifications";
// import GroupNotifications from "./components/NotificationManager/GroupNotifications";
// import TemplateManagement from "./components/NotificationManager/TemplateManagement";


function App() {
  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route path="login" element={<Login />} />

        {/* All other routes require you to be “admin” */}
        <Route
          path="/"
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<Overall />} />
          <Route path="Overall" element={<Overall />} />
          <Route path="mainCommodity" element={<MainCommodity />} />
          <Route path="Spice" element={<Spice />} />
          <Route path="Fruit" element={<Fruit />} />
          <Route path="Pulse" element={<Pulse />} />
          <Route path="OilSeed" element={<OilSeed />} />
          <Route path="Vegetable" element={<Vegetable />} />
          <Route path="RootCrop" element={<RootCrop />} />
          <Route path="BuildingMaterials" element={<BuildingMaterials />} />
          <Route path="GrainsAndCereals" element={<GrainsAndCereals />} />
          <Route path="UserAndNews" element={<UserAndNews />} />
          {/* your ankuaru sub‐routes */}
          <Route path="ankuaru/createPost" element={<CreatePost />} />
          <Route path="ankuaru/addExchangeRate" element={<AddExchangeRate />} />
          <Route path="ankuaru/preViewPosts" element={<PreViewPosts />} />
          <Route path="ankuaru/postOffer" element={<Posting_form_admin />} />
          <Route path="ankuaru/listOffer" element={<ListOffer />} />
          <Route path="ankuaru/createProduct" element={<CreateProduct />} />
          <Route path="ankuaru/createProperty" element={<CreateProperty />} />
          <Route path="ankuaru/users" element={<Users />} />
          <Route path="ankuaru/productPrice" element={<ProductPrice />} />
          <Route path="ankuaru/previewresource" element={<PreViewResource />} />
          <Route path="ankuaru/createresource" element={<CreateResource />} />
          <Route path="ankuaru/postInquiry" element={<Inquiry_form_admin />} />
          <Route
            path="ankuaru/createPropertyValue"
            element={<CreatePropertyValue />}
          />
          <Route path="ankuaru/valueTrend" element={<ValueTrend />} />
          <Route
            path="ankuaru/TotalViewForUserPost"
            element={<TotalViewForUserPost />}
          />
          <Route
            path="ankuaru/TotalPostForUserPost"
            element={<TotalPostForUserPost />}
          />
          <Route
            path="ankuaru/productValueCalc"
            element={<ProductValueCalc />}
          />
          <Route path="ankuaru/PostInfo" element={<PostInfo />} />
          <Route path="ankuaru/editPost/:id" element={<EditPost />} />
          <Route path="ankuaru/PowerBI" element={<PowerBI />} />
          <Route path="ankuaru/ContentListPage" element={<ContentListPage />} />
          <Route path="ankuaru/postStatistics" element={<PostStatistics />} />
          <Route path="ankuaru/addAdmin" element={<AddAdmin />} />
          <Route path="ankuaru/removeAdmin" element={<RemoveAdmin />} />
          <Route
            path="ankuaru/kyc/verified"
            element={
              <RequireRole allowedRoles={["superadmin", "admin"]}>
                <Navigate to="/ankuaru/kyc" replace />
              </RequireRole>
            }
          />
          <Route
            path="ankuaru/kyc/pending"
            element={
              <RequireRole allowedRoles={["superadmin", "admin"]}>
                <Navigate to="/ankuaru/kyc" replace />
              </RequireRole>
            }
          />
          <Route
            path="ankuaru/kyc/rejected"
            element={
              <RequireRole allowedRoles={["superadmin", "admin"]}>
                <Navigate to="/ankuaru/kyc" replace />
              </RequireRole>
            }
          />
          <Route
            path="ankuaru/kyc"
            element={
              <RequireRole allowedRoles={["superadmin", "admin"]}>
                <KYCList />
              </RequireRole>
            }
          />
          {/* NOTE: Notification Manager commented out - not in current project scope */}
          {/* Redirect old notification paths to new paths */}
          {/* <Route
            path="ankuaru/kyc/notifications"
            element={
              <RequireRole allowedRoles={["superadmin", "admin"]}>
                <Navigate to="/ankuaru/notifications" replace />
              </RequireRole>
            }
          />
          <Route
            path="ankuaru/kyc/notifications/users"
            element={
              <RequireRole allowedRoles={["superadmin", "admin"]}>
                <Navigate to="/ankuaru/notifications/users" replace />
              </RequireRole>
            }
          />
          <Route
            path="ankuaru/kyc/notifications/groups"
            element={
              <RequireRole allowedRoles={["superadmin", "admin"]}>
                <Navigate to="/ankuaru/notifications/groups" replace />
              </RequireRole>
            }
          />
          <Route
            path="ankuaru/kyc/notifications/templates"
            element={
              <RequireRole allowedRoles={["superadmin", "admin"]}>
                <Navigate to="/ankuaru/notifications/templates" replace />
              </RequireRole>
            }
          />
          <Route
            path="ankuaru/notifications"
            element={
              <RequireRole allowedRoles={["superadmin", "admin"]}>
                <NotificationManagerLayout />
              </RequireRole>
            }
          >
            <Route index element={<UserNotifications />} />
            <Route path="users" element={<UserNotifications />} />
            <Route path="groups" element={<GroupNotifications />} />
            <Route path="templates" element={<TemplateManagement />} />
          </Route> */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
